import React from 'react';
import Module from 'Components/Core/Module';
import MarketdataGroupSelector from './MarketdataGroupSelector';
import MarketdataChartTile from './MarketdataChartTile';
import MarketdataRangeSelector from './MarketdataRangeSelector';
import './Marketdata.css';

// Charts-Modul: dieselben Watchlists wie "Watchlist Live", aber als
// Kachel-Raster aus Mini-Charts statt einer Tabelle - ein Chart pro Symbol,
// gleiche Reihenfolge (sortorder) und gleiche Groesse wie bisher im
// Detail-Panel des Live-Moduls. Anders als "Watchlist Live" nicht live
// gepollt (Chart-Kerzen aendern sich nicht Sekunde fuer Sekunde relevant),
// sondern einmalig beim Oeffnen/Gruppenwechsel geladen (analog
// MarketdataChart.inc fuers Detail-Panel).
export default function MarketdataCharts(props) {

	const x = props.x;
	const [charts, setCharts] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [error, setError] = React.useState('');
	const [selectedGroupId, setSelectedGroupId] = React.useState(null);
	const [range, setRange] = React.useState('1T');

	function loadCharts() {
		if (selectedGroupId === null) {
			return;
		}
		setLoading(true);
		setError('');
		x.was.axPost('Backend/webapp.php?module=Marketdata&task=MarketdataCharts', { groupid: selectedGroupId, range }, (result) => {
			setLoading(false);
			if (result.data.returncode !== 1) {
				setError(result.data.content?.message || 'Charts konnten nicht geladen werden.');
				setCharts([]);
				return;
			}
			setCharts(result.data.content || []);
		});
	}

	React.useEffect(() => {
		loadCharts();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedGroupId, range]);

	return (
		<Module
			id={props.id}
			x={x}
			classes="module-marketdata-charts"
			title={props.title}
			display={props.display}
			displayTitle="d-block"
			titleToolbar={
				<span className="module-table-title-toolbar">
					<MarketdataGroupSelector x={x} id={props.id} onSelect={setSelectedGroupId} />
					<MarketdataRangeSelector range={range} onChange={setRange} />
					<i
						className="bi bi-pencil module-icon"
						title="Watchlist bearbeiten"
						onClick={() => x.wam.activate('marketdata-watchlist')}
					/>
					<i
						className={'bi bi-arrow-repeat module-icon' + (loading ? ' marketdata-reload-spinning' : '')}
						title="Watchlist-Änderungen laden"
						onClick={loadCharts}
					/>
				</span>
			}
		>
			{loading && charts.length === 0 && <div className="marketdata-detail-hint">Charts werden geladen…</div>}
			{!loading && error && <div className="marketdata-detail-hint">{error}</div>}
			{!loading && !error && charts.length === 0 &&
				<div className="marketdata-empty">Keine Symbole in dieser Watchlist.</div>
			}
			{charts.length > 0 &&
				<div className="marketdata-charts-grid">
					{charts.map((chart) => (
						<MarketdataChartTile key={chart.symbol} symbol={chart.symbol} shortlabel={chart.shortlabel} candles={chart.candles} range={range} />
					))}
				</div>
			}
		</Module>
	)

};
